import PageLayout from '../components/PageLayout';

const NotFoundPage = () => (
	<PageLayout>
		<div className="Page-main">
			<div className="Panel">
				<div className="Panel-header">
					<h1 className="Panel-heading">404 - Stránka nenalezena</h1>
				</div>
				<div className="Panel-main">
					<div className="FormSection">
						<div className="FormSection-header">
							<div className="Subheaderr Subheader--themeLight">
								<div className="Subheader-main">
									<h3 className="Subheader-heading">Litujeme, požadovaná stránka nebyla nalezena.</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</PageLayout>
);

export default NotFoundPage;
